import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.replace";
import axios from 'axios';
import Cookie from 'js-cookie';
var MOA_AUTH_INFO = process.env.VUE_APP_AUTH_INFO || 'MOA_AUTH_INFO';
var MOA_AUTH_PROJECT = process.env.VUE_APP_AUTH_PROJECT;
var MOA_AUTH_URL = process.env.VUE_APP_AUTH_URL || 'https://login.moa.moonton.net';
var MOA_CALLBACK_URL = process.env.BASE_URL.replace(/\/+$/, '') + '/#/moa/login';
// 设置刷新令牌的最小间隔时间（30分钟，单位：毫秒）
var MIN_REFRESH_INTERVAL = 30 * 60 * 1000;

// const info = JSON.parse(localStorage.getItem(MOA_AUTH_INFO) || '{}')
var info = JSON.parse(Cookie.get(MOA_AUTH_INFO) || '{}');
var state = {
  token: info.token || '',
  uid: info.uid || '',
  nick: info.nick || '',
  name: info.name || '',
  avatar: info.avatar || '',
  perms: [],
  lastRefreshTime: 0,
  // 上次刷新令牌的时间戳
  refreshTokenTimer: null // 存储刷新令牌的定时器ID
};
var mutations = {
  UPDATE_USER: function UPDATE_USER(state, info) {
    if (info) {
      state.token = info.token || '';
      state.uid = info.uid || '';
      state.nick = info.nick || '';
      state.name = info.name || '';
      state.avatar = info.avatar || "".concat(MOA_AUTH_URL, "/avatar/").concat(info.nick, "-64.jpg");
    }
    Cookie.set(MOA_AUTH_INFO, JSON.stringify(info || {}), {
      expires: 7,
      domain: process.env.VUE_APP_DOMAIN
    });

    // localStorage.setItem(MOA_AUTH_INFO, JSON.stringify(info || {}))
  },
  UPDATE_PERMS: function UPDATE_PERMS(state, perms) {
    if (perms) {
      state.perms = perms;
    }
  },
  // 设置刷新令牌的定时器ID
  SET_REFRESH_TIMER: function SET_REFRESH_TIMER(state, timerId) {
    state.refreshTokenTimer = timerId;
  }
};
var actions = {
  login: function login(context) {
    var route = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var redirect = window.location.origin + MOA_CALLBACK_URL;
    if (route && route !== '/') {
      redirect += '?route=' + encodeURIComponent(route);
    }
    redirect = encodeURIComponent(redirect);
    window.location.href = "".concat(MOA_AUTH_URL, "/login?project=").concat(MOA_AUTH_PROJECT, "&redirect=").concat(redirect);
  },
  update: function update(_ref, info) {
    var commit = _ref.commit,
      state = _ref.state;
    commit('UPDATE_USER', info);
    // 更新上次刷新时间
    state.lastRefreshTime = Date.now();
  },
  logout: function logout(_ref2) {
    var commit = _ref2.commit,
      state = _ref2.state;
    // 清除刷新令牌的定时器
    if (state.refreshTokenTimer) {
      clearInterval(state.refreshTokenTimer);
      commit('SET_REFRESH_TIMER', null);
    }
    commit('UPDATE_USER', {});
    state.lastRefreshTime = 0;
    var token = encodeURIComponent(state.token);
    var redirect = encodeURIComponent(window.location.origin + MOA_CALLBACK_URL);
    window.location.href = "".concat(MOA_AUTH_URL, "/logout?token=").concat(token, "&project=").concat(MOA_AUTH_PROJECT, "&redirect=").concat(redirect);
  },
  // 设置刷新令牌的定时器
  setupRefreshTimer: function setupRefreshTimer(_ref3) {
    var dispatch = _ref3.dispatch,
      commit = _ref3.commit,
      state = _ref3.state;
    // 如果已经设置了定时器，则不重复设置
    if (state.refreshTokenTimer) {
      return;
    }
    console.log('[Auth] Setting up token refresh timer (interval: 1 hour)');
    var timerId = setInterval(function () {
      dispatch('refresh_token');
    }, 3600 * 1000);
    commit('SET_REFRESH_TIMER', timerId);
  },
  refresh_token: function refresh_token(_ref4) {
    var dispatch = _ref4.dispatch,
      commit = _ref4.commit,
      state = _ref4.state;
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!state.token) {
      return Promise.resolve();
    }
    var now = Date.now();
    // 如果不是强制刷新，且距离上次刷新的时间不足最小间隔，则跳过
    if (!force && now - state.lastRefreshTime < MIN_REFRESH_INTERVAL) {
      console.log("[Auth] Skipping token refresh, last refresh was ".concat(Math.floor((now - state.lastRefreshTime) / 1000), " seconds ago"));
      return Promise.resolve();
    }
    console.log('[Auth] Refreshing token');
    return axios({
      url: MOA_AUTH_URL + '/api/refresh',
      method: 'post',
      data: {
        token: state.token
      }
    }).then(function (result) {
      if (result.data.code === 0) {
        commit('UPDATE_USER', result.data.result);
        // 更新上次刷新时间
        state.lastRefreshTime = now;
        console.log('[Auth] Token refreshed successfully');
      } else {
        console.error('[Auth] Token refresh failed, logging out');
        dispatch('logout');
      }
    }).catch(function (error) {
      console.error('[Auth] Token refresh error:', error);
    });
  },
  get_perms: function get_perms(_ref5) {
    var commit = _ref5.commit,
      state = _ref5.state;
    if (!state.token) {
      return;
    }
    return axios({
      url: MOA_AUTH_URL + '/api/getperms',
      method: 'post',
      data: {
        token: state.token
      }
    }).then(function (result) {
      if (result.data.code === 0) {
        commit('UPDATE_PERMS', result.data.result);
      }
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};